import Dialog from "@mui/material/Dialog";
import { useIsFetching } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SwipeableDrawer } from "src/components/Default/LekUI/SwipableDrawer";
import { SearchInput } from "src/components/GlobalSearch/SearchInput";
import { SearchResults } from "src/components/GlobalSearch/SearchPopper/SearchResults";
import { ShortLimitedAccess } from "src/components/NewComponents/LimitedAccess";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import isMobile from "src/helpers/isMobile";

type GlobalSearchModalProps = {
	onClose: () => void;
	initialValue?: string;
};

export function GlobalSearchModal({
	onClose,
	initialValue = "",
}: GlobalSearchModalProps) {
	const { t } = useTranslation();
	const [searchValue, setSearchValue] = useState(initialValue);
	const isFetching =
		useIsFetching({
			queryKey: ["global-search"],
		}) > 0;

	const content = (
		<>
			<div className="global-search-modal__header">
				<SearchInput
					autoFocus
					className="search-input--large"
					value={searchValue}
					onChange={setSearchValue}
					onClear={() => setSearchValue("")}
					isLoading={isFetching}
					showShortcut={!isMobile()}
					placeholder={t(
						"globalSearch.placeholder",
						"Szukaj pytań, artykułów, fiszek…",
					)}
				/>
			</div>
			{hasLimitedAccess() ? (
				<ShortLimitedAccess />
			) : (
				<SearchResults searchValue={searchValue} onClose={onClose} />
			)}
		</>
	);

	if (isMobile()) {
		return (
			<SwipeableDrawer open onClose={onClose}>
				<div className="global-search-drawer">{content}</div>
			</SwipeableDrawer>
		);
	}

	return (
		<Dialog
			open
			onClose={onClose}
			maxWidth={false}
			slotProps={{ paper: { className: "global-search-modal" } }}
			onKeyDown={(event) => {
				// ⌘K przy otwartym modalu nie otwiera kolejnego
				if ((event.metaKey || event.ctrlKey) && event.key === "k") {
					event.preventDefault();
					event.stopPropagation();
				}
			}}
		>
			{content}
		</Dialog>
	);
}
